<template>
  <label class="switch">
    <input type="checkbox" v-model="model" />
    <div class="slider round text-12 flex items-center relative select-none px-2">
      <span class="absolute text-white" :class="value ? 'left' : 'right'">{{
        value ? $t('has') : $t('has_not')
      }}</span>
    </div>
  </label>
</template>
<script>
export default {
  props: {
    value: [Boolean, Array],
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
<style scoped>
.left {
  top: 4px;
  left: 8px;
}
.right {
  top: 4px;
  right: 8px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 24px;
}
.switch:is(:lang(fa)) {
  position: relative;
  display: inline-block;
  width: 55px;
  height: 24px;
}
.switch:is(:lang(en), :lang(fr), :lang(de)) {
  position: relative;
  display: inline-block;
  width: 80px;
  height: 24px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 0px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #007aff;
}

input:checked + .slider:before {
  -webkit-transform: translateX(75px);
  -ms-transform: translateX(75px);
  transform: translateX(75px);
  background-color: white;
}
input:checked + .slider:is(:lang(fa)):before {
  -webkit-transform: translateX(30px);
  -ms-transform: translateX(30px);
  transform: translateX(30px);
  background-color: white;
}
input:checked + .slider:is(:lang(en), :lang(fr), :lang(de)):before {
  -webkit-transform: translateX(55px);
  -ms-transform: translateX(55px);
  transform: translateX(55px);
  background-color: white;
}

.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
</style>
